import {useMutation, gql} from 'admin/lib/apollo'
import {isArray} from 'lodash'

const MUTATION = gql`
  mutation DestroyRecords($recordType: String!, $recordIds: [String!]!, $notes: String) {
    destroy(recordType: $recordType, recordIds: $recordIds, notes: $notes) {
      ... on Group {
        id
      }
      ... on Invoice {
        id
      }
      ... on RepeatingInvoice {
        id
      }
      ... on Payment {
        id
      }
      ... on Credit {
        id
      }
      ... on Debit {
        id
      }
      ... on Service {
        id
      }
      ... on PaymentRule {
        id
      }
      ... on BankImport {
        id
      }
    }
  }
`

export default (recordType, recordId = []) => {
  const recordIds = isArray(recordId) ? recordId : [recordId]
  const [destroy, {error: destroyError}] = useMutation(MUTATION, {
    variables: {recordType, recordIds},
    flash: 'Successfully deleted',
    update: (cache, {data: {destroy}, errors}) => {
      if (!errors) {
        destroy.forEach(record => {
          cache.evict({id: cache.identify(record)})
          cache.gc()
        })
      }
    }
  })

  return {
    errors: destroyError || {},
    destroy
  }
}
